import React from 'react';

const Footer = () => {
  return (
    <React.Fragment>
      <div className="bg-white shadow-sm rounded-2xl tracking-wide flex w-full flex-col items-center justify-between p-5 xl:flex-row">
        <h5 className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
          <p className="mb-4 text-center text-sm text-[#c51369] sm:!mb-0 md:text-base">
            ©{1900 + new Date().getYear()} Heart Connect. All Rights Reserved.
          </p>
        </h5>
        <div>
          <p className="mb-4 text-center text-sm text-gray-800 sm:!mb-0 md:text-base">
            Design & Developed by Web_Bocket Pvt. Ltd.
          </p>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Footer